export const ChatSituations = {
  NOT_ANSWERED: 'nao_atendida',
  TO_ANSWER: 'atender',
  TRANSFERRED: 'transferida',
  HANGED_UP: 'encerrada',
  ABANDONED: 'abandonada',
  IN_ATTENDANCE: 'em_atendimento',
  EXPIRED: 'expirada',
  WAITING_FOR_ANSWER: 'aguardando_resposta',
  WAITING_IN_QUEUE: 'aguardando_fila',
  ASSIGNED: 'atribuida',
  REDISTRIBUTED: 'redistribuida',
  OVERFLOW: 'transbordo',
  MAX_TIME_IN_QUEUE: 'tempo_maximo_em_fila'
};

export const isChatInWaitingQueue = (situation) => {
  return situation === ChatSituations.WAITING_IN_QUEUE;
};
